// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__34Seo","requiredAsterisk":"Info_requiredAsterisk__2Jrlb"};